/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ArrowUpRightSolidV6 = (props) => (
  <Icon {...props} name="Arrow Up Right Solid V6">
    <path d="M13 4v7a1 1 0 1 1-2 0V6.416L4.706 12.71a.997.997 0 0 1-1.413-.002.999.999 0 0 1 0-1.414l6.294-6.293H4.999a1 1 0 1 1 0-2h7a1 1 0 0 1 1 1z" />
  </Icon>
);

export default ArrowUpRightSolidV6;
